// extracted by mini-css-extract-plugin
export default {"container":"CreateReplenishCFOUnit_container__WKCpz","content":"CreateReplenishCFOUnit_content__3LEYe"};